// extracted by mini-css-extract-plugin
export default {"wrapper":"Information_wrapper__wrlzi","row":"Information_row__Hbacx","info":"Information_info__Uug8v"};